import React, { useContext } from "react";

import { useLocalContent } from "~/sdks/LocalContent/context";

import type { RootProps } from "./types";

export type DefaultContext = {
  isExpanded: boolean;
  isScoresLoading: RootProps["isScoresLoading"];
  isMarkersLoading: RootProps["isMarkersLoading"];
  scoresData: RootProps["scoresData"];
  activeCategory: RootProps["activeCategory"];
  activeCategoryData?: RootProps["activeCategoryData"];
  activeScore: RootProps["activeScore"];
  activeScoreData?: RootProps["activeScoreData"];
  markersData?: RootProps["markersData"];
  onToggleIsExpanded: () => void;
  onSelectCategory?: RootProps["onSelectCategory"];
  onSelectScore?: RootProps["onSelectScore"];
};

const RootElementContext = React.createContext<DefaultContext>(
  {} as DefaultContext
);
const useRootElement = () => useContext(RootElementContext);

const RootElementContextProvider = ({
  isScoresLoading,
  isMarkersLoading,
  scoresData,
  activeCategory,
  activeCategoryData,
  activeScore,
  activeScoreData,
  markersData,
  onSelectCategory,
  onSelectScore,
  children,
}: {
  isScoresLoading: DefaultContext["isScoresLoading"];
  isMarkersLoading: DefaultContext["isMarkersLoading"];
  scoresData: DefaultContext["scoresData"];
  activeCategory: DefaultContext["activeCategory"];
  activeCategoryData?: DefaultContext["activeCategoryData"];
  activeScore: DefaultContext["activeScore"];
  activeScoreData?: DefaultContext["activeScoreData"];
  markersData?: DefaultContext["markersData"];
  onSelectCategory?: DefaultContext["onSelectCategory"];
  onSelectScore?: DefaultContext["onSelectScore"];
  children: React.ReactNode;
}) => {
  const { isCategoriesMenuOpen, handleToggleIsCategoriesMenuOpen } =
    useLocalContent();

  return (
    <RootElementContext.Provider
      value={{
        isExpanded: isCategoriesMenuOpen,
        isScoresLoading,
        isMarkersLoading,
        scoresData,
        activeCategory,
        activeCategoryData,
        activeScore,
        activeScoreData,
        markersData,
        onToggleIsExpanded: handleToggleIsCategoriesMenuOpen,
        onSelectCategory,
        onSelectScore,
      }}
    >
      {children}
    </RootElementContext.Provider>
  );
};

export { useRootElement, RootElementContextProvider };
